export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEJR0JULUVVQy1IYRShogCEPwAAhD4GAIRWAAG8GAAAhFcEDYRGPgC8GoMiAIRCBgGERAIAhD0BALwbCwGEQAEAvBwBAIRDGwC8HQEAvB4BAIRYGwCEVAEAhFUAALwf", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/GBT-EUC-V.bcmap
// module id = 646
// module chunks = 502